import { Add } from '@mui/icons-material'

// @mui/icons-material has no bold/thin weight variants to switch between
// (unlike the variable Material Symbols font) — every icon is a single
// fixed-weight glyph. Add's default fill reads as visibly thin at the small
// sizes it's mostly used at (toolbar "add" buttons), so this adds a
// matching stroke on top of the fill to bulk it up. Centralized here so
// every "add" affordance in the app gets the same weight by default,
// instead of each call site repeating the same sx.
export default function AddIcon({ sx = {}, ...props }) {
  return (
    <Add {...props} sx={{ stroke: 'currentColor', strokeWidth: 1.5, ...sx }} />
  )
}
